export class AccountSummary {
    id: string;
    lastname: string;
    firstname: string;
    displayName: string;
    userId: string;
    accountId: string;
    accountStatusCode: string;
    dateofBirth: Date;
    positionCode: string;
    fromDate: Date;
    toDate: Date;
    roleCode: string;
    organisationName: string;
    mobile: string;
    globalRoleCode: string;
    extOrganisationId: string;
    dioceseName: string;
    claimStatusCode: string;
    accountOrganisationId: string;
    organisationStatusCode: string;
}





// WEBPACK FOOTER //
// ./src/app/models/accountSummary.ts